import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
MatDialogActions,
MatDialogContent,
MatDialogRef,
MatDialogTitle,
} from '@angular/material/dialog';

@Component({
  selector: 'confirm-dialog',
  templateUrl: './confirm.dialog.html',
  styleUrls: ['./confirm.dialog.css'],
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatButtonModule,
  ],
  standalone: true,
})
export class ConfirmDialog {
  title: string;
  actionBtn: string;
  cancelBtn: string;
  message: string;
  constructor(public dialogRef: MatDialogRef<ConfirmDialog>) {
    // Observable.create()
  }

}
